export default "/dist/files/icone_nourriture.b029c2889e2e0c4c081de08f6c5d8115.svg";